import React from "react"

export const CheckedState: React.FC = () => {
  // a11y: decorative — the checkbox input conveys state; hide the icon from SR
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="1"
        y="1"
        width="16"
        height="16"
        rx="1"
        fill="#107BA0"
        stroke="#107BA0"
      />
      <path
        d="M14.8516 4.64844C15.207 4.97656 15.207 5.55078 14.8516 5.87891L7.85156 12.8789C7.52344 13.2344 6.94922 13.2344 6.62109 12.8789L3.12109 9.37891C2.76562 9.05078 2.76562 8.47656 3.12109 8.14844C3.44922 7.79297 4.02344 7.79297 4.35156 8.14844L7.25 11.0195L13.6211 4.64844C13.9492 4.29297 14.5234 4.29297 14.8516 4.64844Z"
        fill="white"
      />
    </svg>
  )
}
